"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlCenterCloseSource = exports.ControlCenterOpenSource = exports.ControlCenterDeeplink = void 0;
var ControlCenterDeeplink;
(function (ControlCenterDeeplink) {
    ControlCenterDeeplink[ControlCenterDeeplink["Main"] = 0] = "Main";
    ControlCenterDeeplink[ControlCenterDeeplink["TimeSpentReminderPage"] = 1] = "TimeSpentReminderPage";
    ControlCenterDeeplink[ControlCenterDeeplink["GameLimitsPage"] = 2] = "GameLimitsPage";
})(ControlCenterDeeplink || (exports.ControlCenterDeeplink = ControlCenterDeeplink = {}));
var ControlCenterOpenSource;
(function (ControlCenterOpenSource) {
    ControlCenterOpenSource["Lobby"] = "lobby";
    ControlCenterOpenSource["UserArea"] = "mini";
    ControlCenterOpenSource["RgPolicy"] = "rg_policy";
    ControlCenterOpenSource["Cashier"] = "cashier";
    ControlCenterOpenSource["Membership"] = "membership";
    ControlCenterOpenSource["PendingAction"] = "pending_action";
    ControlCenterOpenSource["Boss"] = "boss";
    ControlCenterOpenSource["Email"] = "email";
    ControlCenterOpenSource["Promotion"] = "promotion";
    ControlCenterOpenSource["OMG"] = "omg";
})(ControlCenterOpenSource || (exports.ControlCenterOpenSource = ControlCenterOpenSource = {}));
var ControlCenterCloseSource;
(function (ControlCenterCloseSource) {
    ControlCenterCloseSource["MiniSafeZone"] = "MiniSafeZone";
    ControlCenterCloseSource["UserArea"] = "userArea";
    ControlCenterCloseSource["ClientPage"] = "clientPage";
})(ControlCenterCloseSource || (exports.ControlCenterCloseSource = ControlCenterCloseSource = {}));
//# sourceMappingURL=control-center.interfaces.js.map